import React from "react";
import LoaderRows from "components/Loader/Rows";
const DEFAULT_CLASSES = {
  container: "pa3 w-100"
};

const DetailLoader = ({ customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <div className={classes.container}>
      <div className="flex tl fw5 f3 dib mw5">
        <div className="shimmer h3 w5" />
      </div>
      <LoaderRows rows={[75, 63, 40, 78, 47, 35]} />
      <div>
        <div className="shimmer h3 w4 fr" />
      </div>
      <div className="mt5">
        <LoaderRows />
      </div>
    </div>
  );
};

export default DetailLoader;
